import type { PropsWithChildren } from 'react';

import { WithPopover } from '@procurify/ui'

import {
  type IPunchOutOrderInfoProps,
  PunchOutOrderInfo,
} from './PunchOutOrderInfo'
import { PunchOutOrderInfoTooltipStyled } from './styles/PunchOutOrderInfoTooltipStyled'

export const PunchOutOrderInfoTooltip = ({
  isFailedPunchoutOrder,
  confirmationStatus,
  submittedDate,
  confirmationStatusDescription,
  children,
}: PropsWithChildren<IPunchOutOrderInfoProps>) => {
  return (
    <WithPopover
      content={
        <PunchOutOrderInfoTooltipStyled>
          <PunchOutOrderInfo
            confirmationStatus={confirmationStatus}
            submittedDate={submittedDate}
            confirmationStatusDescription={confirmationStatusDescription}
            isFailedPunchoutOrder={isFailedPunchoutOrder}
          />
        </PunchOutOrderInfoTooltipStyled>
      }
      placement='top'
    >
      {children}
    </WithPopover>
  )
}

PunchOutOrderInfoTooltip.displayName = 'PunchOutOrderInfoTooltip'
